import { useEffect, useState } from 'react';
import NativeAd from '../ads/NativeAd';
import SystemStatus from './SystemStatus';
import { CopyIcon, DownloadIcon } from './TranscriptionIcons';

const PROGRESS_STEPS = [
  "Preparant l'àudio",
  "Dividint l'àudio en fragments",
  'Enviant els fragments al servei',
  'Esperant els resultats',
];
const LONG_WAIT_STEP = "Està tardant més de l'habitual";
const MOCK_PROGRESS_DURATION_MS = 10_000;
const MOCK_STEP_DURATION_MS = MOCK_PROGRESS_DURATION_MS / PROGRESS_STEPS.length;
const LONG_WAIT_DELAY_MS = 30_000;

export default function TranscriptionProgress({
  audioUrl,
  onCancel,
  soundEnabled,
  onSoundChange,
  status,
}) {
  const [activeStep, setActiveStep] = useState(0);
  const [showLongWaitStep, setShowLongWaitStep] = useState(false);
  const transcribing = status === 'transcribing';
  const systemMessage = transcribing
    ? 'Transcripció en curs…'
    : "Preparant l'àudio…";

  useEffect(() => {
    const timer = window.setInterval(() => {
      setActiveStep((currentStep) => {
        const nextStep = currentStep + 1;
        if (nextStep === PROGRESS_STEPS.length) window.clearInterval(timer);
        return nextStep;
      });
    }, MOCK_STEP_DURATION_MS);
    const longWaitTimer = window.setTimeout(() => {
      setShowLongWaitStep(true);
      setActiveStep(PROGRESS_STEPS.length);
    }, LONG_WAIT_DELAY_MS);

    return () => {
      window.clearInterval(timer);
      window.clearTimeout(longWaitTimer);
    };
  }, []);

  return (
    <div className="transcription-stage">
      <SystemStatus soundEnabled={soundEnabled} onSoundChange={onSoundChange}>{systemMessage}</SystemStatus>
      {audioUrl && <audio className="transcription-audio" controls src={audioUrl} />}
      <div className="transcription-output-frame">
        <div className="transcription-output-toolbar">
          <div className="transcription-output-actions">
            <button type="button" disabled><CopyIcon /> <span>Copia el text</span></button>
            <button type="button" disabled><DownloadIcon /> <span>Exporta a .srt</span></button>
          </div>
          <label className="transcription-output-filter">
            <input type="checkbox" checked readOnly disabled /> Treure els temps
          </label>
        </div>
        <div className="transcription-progress-panel" role="status" aria-label="Preparació de la transcripció">
          <div className="transcription-progress-heading">
            <span className="transcription-progress-spinner" aria-hidden="true" />
            <strong>Preparant la transcripció…</strong>
          </div>
          <ol>
            {PROGRESS_STEPS.map((step, index) => (
              <li key={step} className={index === activeStep ? 'active' : index < activeStep ? 'complete' : ''}>
                <span aria-hidden="true" />{step}…
              </li>
            ))}
            {showLongWaitStep && (
              <li className="active"><span aria-hidden="true" />{LONG_WAIT_STEP}…</li>
            )}
          </ol>
          <NativeAd />
        </div>
      </div>
      <button type="button" className="cancel transcription-cancel" onClick={onCancel}>Cancel·la</button>
    </div>
  );
}
